import { render, staticRenderFns } from "./BadgeList.vue?vue&type=template&id=6a5778c3&scoped=true"
import script from "./BadgeList.vue?vue&type=script&lang=js"
export * from "./BadgeList.vue?vue&type=script&lang=js"
import style0 from "./BadgeList.vue?vue&type=style&index=0&id=6a5778c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5778c3",
  null
  
)

export default component.exports